import { createSlice } from '@reduxjs/toolkit';

const backlinkfiltersSlice = createSlice({
  name: 'backlinkFilters',
  initialState: {
    relation: 'all',
    domainauthority: [0, 100],
    spamscore: [0, 100],
    filters: []
  },
  reducers: {
    changeRelation: (state, action) => {
      state.relation = action.payload;
    },
    changeDomainauthority: (state, action) => {
      state.domainauthority = action.payload;
    },
    changeSpamscore: (state, action) => {
      state.spamscore = action.payload;
    },
    updateFilter: (state, action) => {
      const filterIndex = state.filters.findIndex(item => {
        return item.id === action.payload.id;
      });
      state.filters[filterIndex] = action.payload;
    },
    removeFromFilters: (state, action) => {
      state.filters = state.filters.filter(
        filter => filter.id !== action.payload
      );
    },
    addToFilters: (state, action) => {
      state.filters = [...state.filters, action.payload];
    },
    resetFilters: () => {
      return backlinkfiltersSlice.getInitialState();
    }
  }
});

export const {
  removeFromFilters,
  addToFilters,
  updateFilter,
  resetFilters,
  changeDomainauthority,
  changeRelation,
  changeSpamscore
} = backlinkfiltersSlice.actions;
export const NonFilterBacklink = backlinkfiltersSlice.getInitialState();
export default backlinkfiltersSlice;
